import { render } from "./Ahref.vue?vue&type=template&id=6bd3ab82&lang=pug"
import script from "./Ahref.vue?vue&type=script&lang=js"
export * from "./Ahref.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__